import React from "react";
import style from "./index.module.less";
const imgSrc = require("../../assets/emptygray.png");
interface IProps {
  txt: string; // 定义props的类型
  imgUrl?: string
}
export default function Empty(props: IProps) {
  const {txt, imgUrl} = props;
  return <div className={style.emptyCont}>
    <img className={style.img} src={imgUrl || imgSrc} alt="" />
    <div className={style.txt}>{txt}</div>
  </div>;
}